import { FC } from "react";
import { TextFormField } from "@blanket/components/formFields/FormFields";

type CompanyContactDetailsProps = {
  namePrefix: string;
  idPrefix: string;
  /**
   * Enkeltmandsvirksomheden skriver blot "E-mailadresse", da virksomheden og
   * personen er den samme. De øvrige oprettelsesblanketter kvalificerer den.
   */
  emailLabel?: string;
};

/**
 * Telefon, virksomhedsmail og den valgfrie domstols-mail — identisk på de tre
 * oprettelsesblanketter bortset fra mail-labelen.
 *
 * Wrapper-div'e ligger bevidst hos kaldsstedet, ikke her: afstanden mellem
 * blokkene er en layout-beslutning der hører til i sektionen.
 */
export const CompanyContactDetails: FC<CompanyContactDetailsProps> = ({
  namePrefix,
  idPrefix,
  emailLabel = "E-mailadresse til virksomheden",
}) => (
  <>
    <div className="blanket-two-col">
      <TextFormField
        name={`${namePrefix}.phone`}
        label="Telefonnummer"
        id={`${idPrefix}-input-phone`}
        isRequired
        type="tel"
      />
      <TextFormField
        name={`${namePrefix}.email`}
        label={emailLabel}
        id={`${idPrefix}-input-email`}
        isRequired
        type="email"
      />
    </div>
    <TextFormField
      name={`${namePrefix}.safetyEmail`}
      label="Eventuel mailadresse til at modtage beskeder fra domstolene"
      id={`${idPrefix}-input-safety-email`}
      type="email"
      helperText="Mails fra minretssag.dk og domstolene sendes til denne mail fsva. alle advokater i firmaet."
    />
  </>
);
